import React, { useCallback } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import search from 'src/assets/images/icons/feather-search.svg';
import checkbox from 'src/assets/images/icons/ionic-ios-checkbox-outline.svg';
import imgAd from 'src/assets/images/anage-select-banner-casal-home.webp';

export default function AdInfo() {
  const handleClickScrollToSearch = useCallback(() => {
    const searchBox = document.getElementById('realestate-search');
    window.scrollTo(0, searchBox.offsetTop - 100);
  }, []);

  return (
    <div className="info-ad">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-lg-5">
                <div className="description">
                  <h2 className="title title-10">
                    O PODER DE REALIZAR EXPERIÊNCIAS
                  </h2>
                  <div className="block">
                    <div className="item">
                      <img alt="" src={checkbox} className="icon" />
                      <div className="item-info">
                        <p className="text text-1">Exclusividade no alto padrão</p>
                        <p className="text text-1">Superamos suas expectativas com as melhores opções de imóveis, nos bairros mais desejados de Joinville.</p>
                      </div>
                    </div>
                    <div className="item">
                      <img alt="" src={checkbox} className="icon" />
                      <div className="item-info">
                        <p className="text text-1">Seriedade nas negociações</p>
                        <p className="text text-1">Garantimos uma transação segura e valorizamos a discrição e a transparência em todas as etapas.</p>
                      </div>
                    </div>
                    <div className="item">
                      <img alt="" src={checkbox} className="icon" />
                      <div className="item-info">
                        <p className="text text-1">Consultoria em imóveis</p>
                        <p className="text text-1">Nossa escuta ativa permite que possamos garantir suas exigências e apresentar resultados efetivos.</p>
                      </div>
                    </div>
                  </div>
                  <RouterLink to="#realestate-search" className="btn btn-1" onClick={handleClickScrollToSearch}>
                    <img alt="" src={search} className="icon" />
                    Encontrar imóveis
                  </RouterLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img alt="" src={imgAd} className="img-fluid img-ad" />
    </div>
  );
}
